import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const storageAccountPlugin = createPlugin({
  id: 'storage-account',
  routes: {
    root: rootRouteRef,
  },
});

export const StorageAccountPage = storageAccountPlugin.provide(
  createRoutableExtension({
    name: 'StorageAccountPage',
    component: () =>
      import('./components/StorageAccountPage').then(m => m.StorageAccountPage),
    mountPoint: rootRouteRef,
  }),
);
